var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row justify-content-center mt-10 mb-5"},[_c('div',{staticClass:"col-md-4 text-center"},[_c('h1',{staticClass:"playfair-display"},[_vm._v("Page not found.")]),_c('p',[_vm._v("Oops. We can't seem to find this.")])])])
}]

export { render, staticRenderFns }